/** Lemon Squeezy hosted checkout (same store used by Firebase webhooks). */

export const CHECKOUT_BASE = 'https://garden-planner.lemonsqueezy.com/buy/';
export const PRODUCT_ANNUAL = 'a11905f7-02da-4dc8-904a-9a3b45bd5182';
export const PRODUCT_FOREVER = 'b4ba3312-bb8d-4cad-aa10-a622a4bc7692';

/**
 * @param {string | null | undefined} productId - Use PRODUCT_FOREVER for lifetime; otherwise annual.
 * @param {{ email?: string, uid?: string } | null} [user] - Firebase user; adds email pre-fill and UID tracking to the URL.
 */
export function getCheckoutUrl(productId, user = null) {
    const id = productId === PRODUCT_FOREVER ? PRODUCT_FOREVER : PRODUCT_ANNUAL;
    let url = CHECKOUT_BASE + id;
    if (user?.email) {
        url += `?checkout[email]=${encodeURIComponent(user.email)}`;
        if (user.uid) {
            url += `&checkout[custom][firebase_uid]=${encodeURIComponent(user.uid)}`;
        }
    }
    return url;
}
